import React from 'react';

const About: React.FC = () => {
  return (
    <div className="page-container">
      <h1 className="page-title">About</h1>
      <div className="about-content">
        <img 
          src="https://jordan-site-photos.s3.us-east-1.amazonaws.com/photo2.jpg" 
          alt="Jordan Molacek playing pedal steel" 
          className="about-image"
        />
        <div className="about-text">
          <h2 style={{ fontSize: '2rem', marginBottom: '1rem', color: 'var(--accent-color)' }}>Jordan Molacek</h2>
          <p>
            Jordan Molacek is a pedal steel guitarist born and raised in Nebraska, now living and playing in Nashville.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
